/** Backend-published default from the insight-config meta surface. */
export const INSIGHT_AUTHORING_MODEL = 'gpt-5.4-mini' as const
